import { useEffect, useState } from 'react';

export function useInitialRender(): boolean {
    const [isRendered, setRendered] = useState<boolean>(false);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Автоматический игнор в рамках DIRECT-288723
        setRendered(true);

        return () => setRendered(false);
    }, []);

    return isRendered;
}
